<template>
    <div class="wrapper">
        <!-- header -->
        <div class="header h-clear" style="position: absolute">
            <b-row no-gutters>
                <b-col cols="auto">
                    <b-button to="/" variant="link" class="text-dark">
                        <i class="material-icons">home</i>
                    </b-button>
                </b-col>
                <b-col class="text-center"></b-col>
                <b-col cols="auto"></b-col>
            </b-row>
        </div>
        <!-- header ends -->

        <transition name="slide" mode="out-in">
            <router-view @loader="hideLoader"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: "AuthComponent",
    methods: {
        hideLoader() {
            this.$emit('loader');
        }
    }
}
</script>
